import { useState } from 'react';
import { FormikHelpers } from 'formik';
import { accountStatusMap } from 'constants/accountStatuses';
import { useSignIn, useSignUp, useToast } from 'hooks';
import { checkIfError } from 'utils/helpers';
import PendingApproval from './PendingApproval';
import UserForm, { UserFormValues } from './UserForm';

type RegisterProps = {
  url?: string;
};

const Register = ({ url }: RegisterProps) => {
  const [signIn, { error: loginError }] = useSignIn();
  const [signUp, { error: registerError }] = useSignUp();

  const [showToast] = useToast();

  const [pendingApproval, setPendingApproval] = useState(false);

  const handleRegister = async (values: UserFormValues, { setSubmitting }: FormikHelpers<UserFormValues>) => {
    const { confirmPassword, recaptcha, ...fieldValues } = values;

    const phoneValues = {
      phone: values.phone.replace(/\D/g, ''),
    };
    const signUpResponse = await signUp({
      ...fieldValues,
      ...phoneValues,
      registerUrl: url,
    });

    if (checkIfError(signUpResponse)) {
      setSubmitting(false);
      return;
    }

    const isApproved = signUpResponse?.approvalStatus === accountStatusMap.approved.toLowerCase();

    if (signUpResponse?.id && isApproved) {
      await signIn(values.email, values.password);
    }

    setPendingApproval(!isApproved);

    setSubmitting(false);

    if (isApproved) {
      showToast({ message: 'New account created successfully.' });
    }
  };

  return pendingApproval && !registerError ? (
    <PendingApproval />
  ) : (
    <UserForm
      onSubmit={handleRegister}
      error={loginError ?? registerError}
      initialValues={{
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        country: '',
        state: '',
        zipCode: '',
        company: '',
      }}
      buttonContainerProps={{
        display: 'flex',
        justifyContent: 'center',
        mb: 4,
      }}
      buttonProps={{ size: 'lg', mt: 4, w: '100%' }}
    />
  );
};

export default Register;
